<template>
  <ul class="left-menu">
    <li>
      <a
        href="#"
        class="js-sidebar-open"
        :class="{ active : openMenu }"
        @click="setOpen"
      >
        <app-icon
          name="olympus-menu-icon"
          color="dark-gray"
          size="normal"
        />
      </a>
    </li>
    <li>
      <router-link to="/tickets">
        <app-icon-multiple
          name="nico-menu-tickets"
          tooltip="Tickets one"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>
    <li>
      <router-link to="/shopping">
        <app-icon
          name="olymp-shopping-bag-icon"
          tooltip="Shopping"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/health">
        <app-icon
          name="olymp-stats-icon"
          tooltip="Health"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/life-story-timeline">
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="Life Story Timeline"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>
    <!--<li>
      <router-link to="/moments">
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="Moments Timeline"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li> -->
    <li>
      <router-link to="/articles">
        <app-icon
          name="olymp-newsfeed-icon"
          color="dark-gray"
          size="medium"
          tooltip="Articles"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/books">
        <app-icon-multiple
          name="nico-books-icon"
          tooltip="Books"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/timeline">
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="Timeline"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/links">
        <app-icon-multiple
          name="nico-link-icon"
          tooltip="Links"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/movies">
        <app-icon-multiple
          name="nico-video-icon"
          tooltip="Movies"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/food">
        <app-icon-multiple
          name="nico-food-icon"
          tooltip="Food"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>



    <li>
      <router-link to="/chat">
        <app-icon-multiple
          name="nico-chat-icon"
          tooltip="Chat"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>




    <li>
      <router-link to="/quotes">
        <app-icon-multiple
          name="nico-quote-icon"
          tooltip="Quotes"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/songs">
        <app-icon-multiple
          name="olymp-headphones-icon"
          tooltip="Songs"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/afteridie">
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="After I Die"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>
  </ul>
</template>

<script>
// eslint-disable-next-line
// import Ps from 'perfect-scrollbar';
// eslint-disable-next-line
// import '../../../css/perfect-scrollbar.css';
import AppIconMultiple from '../AppIconMultiple'
import AppIcon from '../AppIcon'

export default {
  name: 'Personal',
  components: {AppIcon, AppIconMultiple}, //
  props: {
    // openMenuVar: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // computed: {
  //   openMenu() {
  //     return this.openMenuVar;
  //   },
  // },
  data () {
    return {
      openMenu: false,
    }
  },
  watch: {
    // openMenuVar() {
    //   // this.openMenu = this.openMenuVar;
    //   console.log(this.openMenuVar);
    // },
  },
  methods: {
    getLink (item) {
      return `/${this.ppa}/${item}`
    },
    getLinkArticle() {
      return ['personal', 'mental'].includes(this.ppa)
    },
    setOpen() {
      this.openMenu = !this.openMenu
      this.$emit('openmenu', true);

    }
  },
}
</script>
